/**
 * Boolean-Widget der Spaltenfilter (Auftrag "Bestellboard-Filter datentypgerecht bauen",
 * 2026-09-01) - NEUBAU ohne Bestandsvorbild. Ersetzt die bisherigen Magic Strings
 * `"payment"`/`"__EMPTY__"` durch einen echten Dreifach-Zustand: Alle (kein Filter) / Ja / Nein.
 * Heute die Boolean-Spalten sind "Zahlung anstoßen" (`payment`) und "Zollinstruktionen anstoßen"
 * (`zoll`), siehe `lib/orderList.ts#ORDER_LIST_BOOLEAN_KEYS`.
 *
 * "Ware eingebucht" (`booked`) war bis 2026-10-20 ebenfalls eine Boolean-Spalte; seit dem Auftrag
 * "Ware eingebucht mit Datum" hat sie ein eigenes Widget (`EingebuchtFilter.tsx`: Datumsbereich plus
 * Zustandsauswahl, `lib/orderList.ts#ORDER_LIST_EINGEBUCHT_KEYS`).
 */
export interface BooleanFilterProps {
  label: string;
  wert: boolean | undefined;
  onAendern: (wert: boolean | undefined) => void;
}

export function BooleanFilter({ label, wert, onAendern }: BooleanFilterProps) {
  const knopf = (ziel: boolean | undefined, text: string) => (
    <button
      type="button"
      className="spaltenfilter-boolean-knopf"
      aria-pressed={wert === ziel}
      onClick={() => onAendern(ziel)}
    >
      {text}
    </button>
  );
  return (
    <div className="spaltenfilter-boolean" role="group" aria-label={`${label} filtern`}>
      {knopf(undefined, "Alle")}
      {knopf(true, "Ja")}
      {knopf(false, "Nein")}
    </div>
  );
}
